import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Materials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/OrderProcess.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sectors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Services.tsx");
